export enum Colors {
  Transparent = 'transparent',
  Gray = 'gray',
}
